import config from '@project/config';
import { useVerifyRecaptcha } from '@project/queries';
import React, { useRef } from 'react';
import GoogleReCaptchaCheckbox from 'react-google-recaptcha';
import toast from 'react-hot-toast';

type RecaptchaComponentProps = {
  setRebotCheck: (value: any) => void;
};

const Component = ({ setRebotCheck }: RecaptchaComponentProps) => {
  const recaptchaRef = useRef<GoogleReCaptchaCheckbox>(null);

  const handleVerifyRecaptcha = async (token: any) => {
    try {
      setRebotCheck(false);
      const response = await useVerifyRecaptcha(token);

      if (response && response.success === true) {
        setRebotCheck(response.success);
      } else {
        recaptchaRef.current?.reset();
        toast.error('reCaptcha verification failed');
      }
    } catch (error) {
      recaptchaRef.current?.reset();
      toast.error('reCaptcha verification failed');
    }
  };

  return (
    <div className="my-2">
      <GoogleReCaptchaCheckbox
        sitekey={config.recaptchaSiteKey}
        onChange={handleVerifyRecaptcha}
        ref={recaptchaRef}
      />
    </div>
  );
};

export const RecaptchaComponent = React.memo(Component);
